import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase10 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2025-01-01',
                    revenue_net_pln: 2437292.69,
                },
                {
                    date: '2025-04-01',
                    revenue_net_pln: 24910777.61,
                },
                {
                    date: '2025-07-01',
                    revenue_net_pln: 20434362.04,
                },
                {
                    date: '2025-10-01',
                    revenue_net_pln: 20084968.06,
                },
                {
                    date: '2026-01-01',
                    revenue_net_pln: 20289645.49,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
